class Video {
    constructor($el) {
        this.$el = $el;
        this.$locations = $el.find('[data-video="location"].hero__legende-text');
        this.$videoItem = $el.find('[data-video="video"]');
        this.currentLocationIndex = 0;
        this.intervalId = null;
        this.hasStarted = false;
        this.init();
    }

    init = () => {
        if (!this.$videoItem.length || !this.$locations.length) return;
        this.$locations.hide();
        this.$videoItem.on('play', this.playHandler);
        this.$videoItem.on('pause', this.pauseHandler);
        this.$videoItem.on('ended', this.endedHandler);
    }

    pauseHandler = () => {
        this.clearInterval(); 
    }

    playHandler = () => {
        if (!this.hasStarted) {
            this.hasStarted = true;
            this.currentLocationIndex = 0; 
            this.showLocation(this.currentLocationIndex);
        }


        this.clearInterval();
        this.intervalId = setInterval(this.nextLocation, 5000);
    }

    endedHandler = () => {
        this.clearInterval();
        this.hasStarted = false;
        this.currentLocationIndex = 0;
        this.$locations.hide(); 
    }

    showLocation = (index) => {
        this.$locations.hide();
        const $currentLocation = this.$locations.eq(index);
        $currentLocation.show();
    }

    nextLocation = () => {
        this.currentLocationIndex = (this.currentLocationIndex + 1) % this.$locations.length;
        this.showLocation(this.currentLocationIndex);
    }

    clearInterval = () => {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

export default Video;
